import { ChevronDown } from 'react-feather';
import { Icon } from '@/components/Icon/Icon';

import classes from './Legend.module.css';
import { useDisclosure } from '@mantine/hooks';

export const Legend = (
  props: { children: React.ReactNode[] } & React.HTMLAttributes<HTMLDivElement>
) => {
  const { children, ...otherProps } = props;

  const [showLegend, { toggle: toggleLegend }] = useDisclosure(true);

  if (children.filter((c) => c).length === 0) {
    return null;
  }

  return (
    <div
      className={`${classes.wrapper} ${showLegend ? classes.opened : classes.closed}`}
      {...otherProps}
    >
      <button
        type="button"
        data-testid="legend-hide-button"
        className={classes.hideButton}
        onClick={toggleLegend}
      >
        <ChevronDown size={16} />
      </button>
      <div className={classes.content} data-testid="legend-main-content">
        {children}
      </div>

      <div
        className={classes.collapsedItems}
        onClick={toggleLegend}
        data-testid="legend-collapsed-items"
      >
        <Icon name="MapLegend" size={16} />
        <span>Legend</span>
      </div>
    </div>
  );
};
